import { CustomUserType } from "../profiles/authTypes";

// User type in Fellowship Search Results
export interface FellowshipUserType extends CustomUserType { 
  profile_image?: string | null;
  is_verified_identity?: boolean;
  is_townlit_verified?: boolean;
  fellowship_id?: number;
}

// Fellowship Request object
export interface FellowshipRequestType {
  id: number;
  from_user: FellowshipUserType;
  to_user: FellowshipUserType;
  fellowship_type: string;
  reciprocal_fellowship_type: string | null;
  created_at: string;
}

// Fellowship List object
export interface FellowshipType {
  id: number;
  user: FellowshipUserType;
  relationship_type: string;
  is_hidden_by_confidants: boolean;
}

// Fellowship state type
export interface FellowshipStateType {
  searchResults: FellowshipUserType[];
  sentRequests: FellowshipRequestType[];
  receivedRequests: FellowshipRequestType[];
  fellowshipList: FellowshipType[];
  loading: boolean;
  error: string | null;
  successMessage: string | null;
}



/** One fellowship edge returned from MemberSerializer.litcovenant (nested) */
export interface LitCovenantFellowshipType {
  id: number;
  from_user: FellowshipUserType;
  to_user: FellowshipUserType;
  fellowship_type: string;                // as saved
  reciprocal_fellowship_type: string | null;
  status: "Accepted" | "Pending" | "Rejected";
  created_at: string;                     // ISO
}

/** Helpers to resolve POV (owner = member.user.id) */
export const getRelationshipFromPOV = (
  f: LitCovenantFellowshipType | null | undefined,
  memberUserId: number
): string => {
  if (!f) return "";
  const self = f.from_user?.id === memberUserId;
  return self ? (f.fellowship_type || "") : (f.reciprocal_fellowship_type || "");
};

export const getOppositeUserFromPOV = (
  f: LitCovenantFellowshipType | null | undefined,
  memberUserId: number
): FellowshipUserType | any => {
  if (!f) return null;
  return f.from_user?.id === memberUserId ? f.to_user : f.from_user;
};
